<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form nz-form class="form" nzLayout="horizontal">
  <div class="drawer-form-wrapper">
    <app-student-info-card
      [student]="caseParams.case?.student"
      [supervisorName]="caseParams.case?.supervisorName">
    </app-student-info-card>
    <app-behavior-info-card
      [mode]="mode"
      [behaviorCategoryName]="behavior?.behaviorCategoryName"
      [behaviorTypes]="behavior?.behaviorCategoryTypes">
    </app-behavior-info-card>

    <div *ngIf="mode === 'view'" class="header-with-cta mb-24">
      <h3 class="title s-18">Applied Strategies</h3>
      <button
        nz-button
        type="button"
        [disabled]="loading$ | async"
        (click)="handleCancelStep()"
        nzType="primary">
        Add New
      </button>
    </div>

    <nz-divider
      *ngIf="mode !== 'view' && mode !== 'edit'"
      class="sec-divider" />

    <div *ngIf="!showGuideMe && mode !== 'view' && mode !== 'edit'">
      <form [formGroup]="strategiesForm">
        <h4 class="title s-16 mb-16">Available options</h4>
        <div class="form-grid">
          <app-search-select
            label="Behavior strategy type"
            inputId="behaviorStrategy"
            [control]="strategiesForm.get('type')!"
            [useDefaultProactiveStrategy]="true"
            [defaultOption]="{
              id: +(strategiesForm.get('type')?.value ?? 0),
              value: strategiesForm.get('type')?.value ?? '',
            }"
            lookupType="StrategyType"
            [optionOverflowSize]="7"
            placeholder="Search Behavior strategy type"
            noDataText="No Strategy type found"
            requiredErrorMessage="Please select Behavior strategy type">
          </app-search-select>
        </div>
        <div class="radio-wrapper mb-16">
          <nz-radio-group
            [(ngModel)]="selectedOption"
            (ngModelChange)="handleOptionChange($event)"
            [ngModelOptions]="{ standalone: true }"
            name="selectedOption"
            [nzDisabled]="!isTypeSelected">
            <label
              nz-radio
              [nzValue]="'Guide me'"
              class="box-radio"
              tabindex="0">
              Guide me
            </label>
            <label
              nz-radio
              [nzValue]="'Create my own'"
              class="box-radio"
              tabindex="0">
              Create my own
            </label>
          </nz-radio-group>
        </div>
      </form>
    </div>

    <!-- Guide me form start -->
    <div *ngIf="showGuideMe">
      <nz-form-item *ngIf="mode !== 'view' && mode !== 'edit'">
        <nz-form-label>
          <p class="form-desc">
            The following list of {{ getStrategyTypeText() }} might be
            appropriate for addressing this challenging behavior. The list is
            organized from top to bottom based on how closely these suggested
            strategies match the defined behavior. Remember to modify each
            strategy to make sure it is individualized for the student and the
            environment in which it will be implemented. Also keep in mind that
            you can create your own strategies from scratch if you prefer.
          </p>
        </nz-form-label>
      </nz-form-item>
      <nz-table
        *ngIf="mode !== 'view' && mode !== 'edit'"
        #rowSelectionTable
        [nzData]="(strategies$ | async) ?? []"
        [nzFrontPagination]="false"
        [nzLoading]="loading$ | async"
        [nzTotal]="(stratCount$ | async) ?? 0"
        [(nzPageIndex)]="defaultParams.pageIndex"
        (nzQueryParams)="onQueryParamsChange($event)"
        [nzScroll]="{ x: '1200' }">
        <thead>
          <tr>
            <th nzWidth="60px"></th>
            <th
              nzWidth="150px"
              [nzSortFn]="true"
              [nzColumnKey]="'behaviorStrategyName'">
              Behavior Strategy
            </th>
            <th nzWidth="300px" [nzSortFn]="true" [nzColumnKey]="'title'">
              Type
            </th>
            <th nzRight nzWidth="50px" nzAlign="center">Video</th>
          </tr>
        </thead>
        <tbody>
          @for (data of rowSelectionTable.data; track data) {
            <tr>
              <td nzWidth="60px">
                <ng-container *ngIf="options.includes(5)">
                  <div class="strategy-actions">
                    <nz-radio-group
                      [(ngModel)]="selectedId"
                      [ngModelOptions]="{ standalone: true }">
                      <label
                        nz-radio
                        [nzValue]="data.id"
                        (keydown.enter)="
                          setSelectedId(data.id, 'publishStrategies')
                        "
                        (click)="setSelectedId(data.id, 'publishStrategies')"
                        tabindex="0">
                      </label>
                    </nz-radio-group>
                    <button
                      (click)="openProactiveStrategyDrawer(data)"
                      nz-button
                      type="button"
                      nzType="text">
                      <svg-icon
                        [title]="'View Strategy'"
                        src="/assets/icon/icon-arrow-right.svg"
                        class="icon s-12"></svg-icon>
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="!options.includes(5)">
                  <div class="strategy-actions">
                    <label
                      nz-checkbox
                      [ngModel]="selectedIds.includes(data.id)"
                      (ngModelChange)="onCheckboxChange(data.id, $event)"
                      [ngModelOptions]="{ standalone: true }">
                    </label>
                    <button
                      (click)="openProactiveStrategyDrawer(data)"
                      nz-button
                      type="button"
                      nzType="text">
                      <svg-icon
                        [title]="'View Strategy'"
                        src="/assets/icon/icon-arrow-right.svg"
                        class="icon s-12"></svg-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td [title]="data.behaviourStrategyTypeName">
                <button
                  nz-button
                  type="button"
                  nzType="text"
                  role="button"
                  class="cursorPointer"
                  (click)="openProactiveStrategyDrawer(data)">
                  {{ data.behaviourStrategyTypeName }}
                </button>
              </td>
              <td [title]="data.title">{{ data.title }}</td>
              <td nzRight nzWidth="50px">
                <div class="action-btn-wrapper">
                  <button
                    *ngIf="data.videoUrl"
                    nz-button
                    type="button"
                    nzType="text"
                    class="action-btn"
                    (click)="openVideoUrl(data.videoUrl)">
                    <svg-icon
                      [title]="'Play Video'"
                      src="/assets/icon/icon-play.svg"
                      class="icon s-20"></svg-icon>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>

    <nz-table
      *ngIf="mode === 'view'"
      #sortSelectionTable
      [nzData]="(flattenedStrategies$ | async) ?? []"
      [nzLoading]="loading$ | async"
      [nzFrontPagination]="false"
      [nzTotal]="(totalRows$ | async) ?? 0"
      [(nzPageIndex)]="defaultParams.pageIndex"
      [nzPageSize]="defaultParams.pageSize"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzScroll]="{ x: '1200' }">
      <thead>
        <tr>
          <th
            nzWidth="150px"
            [nzSortFn]="true"
            [nzColumnKey]="'behaviourStrategyTypeName'">
            Behavior Strategy Type
          </th>
          <th nzWidth="300px" [nzSortFn]="true" [nzColumnKey]="'title'">
            Title
          </th>
          <th nzWidth="200px" [nzSortFn]="true" [nzColumnKey]="'status'">
            Status
          </th>
          <th nzWidth="100px" [nzSortFn]="true" [nzColumnKey]="'createdDate'">
            Created Date
          </th>
          <th nzWidth="100px" [nzSortFn]="true" [nzColumnKey]="'updatedDate'">
            Updated Date
          </th>
          <th nzRight nzWidth="100px" nzAlign="center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let strategy of sortSelectionTable.data">
          <td
            [title]="strategy.behaviourStrategyTypeName"
            class="cursorPointer"
            (click)="openProactiveStrategyDrawer(strategy)">
            {{ strategy.behaviourStrategyTypeName }}
          </td>
          <td
            class="cursorPointer"
            (click)="openProactiveStrategyDrawer(strategy)"
            [title]="strategy.title">
            {{ strategy.title }}
          </td>
          <td [title]="strategy.statusId">
            <div
              class="status"
              [class.active]="strategy.statusId === 1"
              [class.inactive]="strategy.statusId === 2">
              <span>{{ getStatusText(strategy.statusId) }}</span>
            </div>
          </td>
          <td [title]="strategy.createdDate | userDate: 'MM/dd/yyyy'">
            {{ strategy.createdDate | userDate: 'MM/dd/yyyy' }}
          </td>

          <td [title]="strategy.updatedDate | userDate: 'MM/dd/yyyy'">
            {{ strategy.updatedDate | userDate: 'MM/dd/yyyy' }}
          </td>
          <td nzRight nzWidth="100px">
            <div class="action-btn-wrapper">
              <button
                *ngIf="strategy.videoUrl"
                nz-button
                type="button"
                nzType="text"
                class="action-btn"
                (click)="openVideoUrl(strategy.videoUrl)">
                <svg-icon
                  [title]="'Play Video'"
                  src="/assets/icon/icon-play.svg"
                  class="icon s-20"></svg-icon>
              </button>
              <button
                nz-button
                type="button"
                nzType="text"
                class="action-btn"
                (click)="openEditOwnStrategyComponent(strategy)">
                <svg-icon
                  [title]="'Edit Strategy'"
                  src="/assets/icon/icon-edit.svg"
                  class="icon s-20"></svg-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <h3
      *ngIf="selectedOption === 'Create my own' && mode === 'create'"
      class="title s-18 mt-16 mb-12">
      Available District options
    </h3>
    <nz-table
      *ngIf="selectedOption === 'Create my own' && mode === 'create'"
      #publishStrategies
      [nzData]="(publishStrategies$ | async) ?? []"
      [nzLoading]="loading$ | async"
      [nzFrontPagination]="false"
      [nzTotal]="(pubCount$ | async) ?? 0"
      [(nzPageIndex)]="defaultParams.pageIndex"
      [nzPageSize]="10"
      (nzQueryParams)="onPublishStrategyQueryParamsChange($event)"
      [nzScroll]="{ x: '1200' }">
      <thead>
        <tr>
          <th nzWidth="60px"></th>
          <th nzWidth="150px" [nzSortFn]="true" [nzColumnKey]="'title'">
            Behavior Strategy
          </th>
          <th nzWidth="300px" [nzSortFn]="true" [nzColumnKey]="'description'">
            Description
          </th>
        </tr>
      </thead>
      <tbody>
        @for (strategy of publishStrategies.data; track strategy) {
          <tr>
            <td nzWidth="60px">
              <ng-container *ngIf="options.includes(5)">
                <div class="strategy-actions">
                  <nz-radio-group
                    [(ngModel)]="selectedId"
                    [ngModelOptions]="{ standalone: true }">
                    <label
                      nz-radio
                      [nzValue]="strategy.id"
                      (keydown.enter)="
                        setSelectedId(strategy.id, 'publishStrategies')
                      "
                      (click)="setSelectedId(strategy.id, 'publishStrategies')"
                      tabindex="0">
                    </label>
                  </nz-radio-group>
                  <button
                    nz-button
                    (click)="openProactiveStrategyDrawer(strategy)"
                    type="button"
                    nzType="text">
                    <svg-icon
                      [title]="'View Strategy'"
                      src="/assets/icon/icon-arrow-right.svg"
                      class="icon s-12"></svg-icon>
                  </button>
                </div>
              </ng-container>

              <ng-container *ngIf="!options.includes(5)">
                <div class="strategy-actions">
                  <label
                    nz-checkbox
                    [ngModel]="selectedIds.includes(strategy.id)"
                    (ngModelChange)="onCheckboxChange(strategy.id, $event)"
                    [ngModelOptions]="{ standalone: true }">
                  </label>
                  <button
                    (click)="openProactiveStrategyDrawer(strategy)"
                    nz-button
                    type="button"
                    nzType="text">
                    <svg-icon
                      [title]="'View Strategy'"
                      src="/assets/icon/icon-arrow-right.svg"
                      class="icon s-12"></svg-icon>
                  </button>
                </div>
              </ng-container>
            </td>
            <td
              [title]="strategy.title"
              class="cursorPointer"
              (click)="openProactiveStrategyDrawer(strategy)">
              {{ strategy.title }}
            </td>
            <td [title]="strategy.description">{{ strategy.description }}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
  <div class="display-flexustify-content-between drawer-footer">
    <div class="footer-left">
      <button
        nz-button
        type="button"
        nzType="default"
        [disabled]="mode === 'view'"
        (click)="onCancelled()">
        Cancel
      </button>
    </div>
    <div class="footer-right" *ngIf="mode !== 'view'">
      <button
        nz-button
        type="button"
        nzType="default"
        [disabled]="isPrevDisabled && (mode === 'edit' || mode === 'create')"
        (click)="handleCancelStep()">
        Prev
      </button>
      <button nz-button type="button" nzType="primary" (click)="handleNext()">
        Next
      </button>
    </div>
  </div>
</form>

<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="showModal()">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon">
        <svg-icon
          src="/assets/icon/icon-print.svg"
          class="icon s-20"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Behavior Strategies Added</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        The selected behavior strategies have been added to the student's plan.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleCancel()">
        Add More
      </button>
      <button
        type="button"
        nz-button
        [nzType]="'primary'"
        class="btn"
        (click)="handleOk()">
        Close
      </button>
    </div>
  </ng-template>
</nz-modal>

<app-video-modal [(visible)]="isVideoVisible" [videoUrl]="videoUrl">
</app-video-modal>

<ng-template #drawerBehaviorStrategies>
  <app-drawer-header
    [title]="'Manage Behavior Strategies'"
    [subtitle]="'Strategies'"
    [breadcrumbText]="caseParams.case?.student?.firstName || ''"
    (close)="closeManageBehaviorStrategiesDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #drawerBehaviorCreate>
  <app-drawer-header
    [title]="mode === 'edit' ? 'Edit Strategy' : 'Create Strategy'"
    subtitle="Strategies"
    [breadcrumbText]="caseParams.case?.student?.firstName || ''"
    (close)="closeCreateBehaviorStrategiesDrawer()">
  </app-drawer-header>
</ng-template>
